import { render, staticRenderFns } from "./ShoppingSetupModal.vue?vue&type=template&id=1d04dda4&scoped=true&"
import script from "./ShoppingSetupModal.vue?vue&type=script&lang=js&"
export * from "./ShoppingSetupModal.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingSetupModal.vue?vue&type=style&index=0&id=1d04dda4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d04dda4",
  null
  
)

export default component.exports